import { Box, Button, Stack } from "@compass/core";
import { CustomFilter as CustomFilterModel, CustomFilterOperator, CustomReportProperty } from "generated/openApi";
import produce from "immer";
import { CustomEntityOption, CustomFilter } from "./CustomFilter";

export const CustomFilters = (props: {
  filters: CustomFilterModel[] | undefined;
  setFilters: (filters: CustomFilterModel[] | undefined) => void;
  properties: CustomReportProperty[] | undefined;
  allowedEntityTypes: CustomEntityOption[];
}) => {

  return (
    <Stack direction="column" spacing="sm">
      {props.filters?.map((filter, index) => (
        <CustomFilter
          filter={filter}
          setFilter={(updatedFilter) =>
            props.setFilters(
              produce(props.filters, (draft) => {
                const previousEntity = draft![index].entity;
                const newEntity = updatedFilter.entity;

                if (previousEntity !== newEntity) {
                  draft![index] = {
                    entity: newEntity,
                    // operator: CustomFilterOperator.Equal,
                  } as CustomFilterModel;
                } else {
                  draft![index] = updatedFilter;
                }
              })
            )
          }
          removeFilter={() =>
            props.setFilters(
              produce(props.filters, (draft) => {
                draft!.splice(index, 1);
              })
            )
          }
          property={props.properties?.find(p => p.entityType == filter.entity)}
          allowedEntityTypes={props.allowedEntityTypes}
        />
      ))}

      <Box>
        <Button
          onClick={() =>
            props.setFilters(
              props.filters
                ? [...props.filters, {} as CustomFilterModel]
                : [{} as CustomFilterModel]
            )
          }
          variant="outlined"
        >
          + Smart Filter
        </Button>
      </Box>
    </Stack>
  );
};
